/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */

/**
 * Get word counts from riche text editor
 * @param {string} text target text to count words length
 *
 * @typedef {Object} Count, a word and characters counts
 * @property {number} count.words
 * @property {number} count.chars
 *
 * @returns {Count}
 */
export function getRichEditorCount(text) {
    if (typeof text !== 'string') {
        return {
            words: 0,
            chars: 0
        };
    }
    const wordsMatchRegExp = new RegExp('([\\p{L}\\p{N}]+\\S?)+', 'gu');
    const detectedWords = text.match(wordsMatchRegExp) || [];
    const detectedChars = text.replace(/\n/g, '') || '';

    return {
        words: detectedWords.length,
        chars: detectedChars.length
    };
}

/**
 * Get word counts from simple text area
 * @param {string} text target text to count words length
 *
 * @typedef {Object} Count, a word and characters counts
 * @property {number} count.words
 * @property {number} count.chars
 *
 * @returns {Count}
 */
export function getPlainEditorCount(text) {
    if (typeof text !== 'string') {
        return {
            words: 0,
            chars: 0
        };
    }
    const wordMatches = text.match(/[^\s.,:;?!&#%/*+=]+/g) || [];

    return {
        words: wordMatches.length,
        chars: text.length
    };
}
